import(/* webpackMode: "eager" */ "/codebuild/output/src2431541508/src/src/app/global-error.tsx");
